import { useEffect, useState } from 'react';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Box from '@mui/material/Box';

import menuIcon from 'assets/header/menu-icon.png';
import closeIcon from 'assets/header/close-icon.png';
import logo from 'assets/logo.svg';

import {
  MobileHeaderContainer,
  MobileHeaderTopLevelLink,
  MobileNavigation,
  Divider,
  ContactUsButton,
  LogoLink,
  Container,
  MenuButton,
  HeaderLinkGroupTitle,
  MobileHeaderLink,
} from './MobileHeader.style';
import {
  aboutMeta,
  autoDockingMeta,
  automatedDataPipelinesMeta,
  careersMeta,
  computerMeta,
  homeMeta,
  industriesMeta,
  maritimeMeta,
  mobileMeta,
  otherMeta,
  platformMeta,
} from 'constants/pages';

type MobileHeaderProps = {
  openModal: () => void;
};

export const MobileHeader = ({ openModal }: MobileHeaderProps) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const onClick = () => {
    setIsOpen((value: boolean) => !value);
  };

  const closeMenu = () => {
    if (isOpen) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    return () => {
      setIsOpen(false);
    };
  }, []);

  return (
    <>
      <div style={{ height: '60px' }} />
      <ClickAwayListener onClickAway={closeMenu}>
        <MobileHeaderContainer onClick={closeMenu} sx={{ height: isOpen ? '100vh' : undefined }}>
          <Container>
            <LogoLink to={homeMeta.url}>
              <img src={logo} alt="logo icon" />
            </LogoLink>
            <MenuButton size="medium" onClick={onClick}>
              <img alt="header-menu-toggle" src={isOpen ? closeIcon : menuIcon} loading="lazy" />
            </MenuButton>
          </Container>
          {isOpen && (
            <MobileNavigation component="nav">
              <MobileHeaderTopLevelLink onClick={closeMenu} to={platformMeta.url}>
                platform
              </MobileHeaderTopLevelLink>

              <Divider />
              {/* <MobileHeaderTopLevelLink onClick={closeMenu} to={industriesMeta.url}>
                industries
              </MobileHeaderTopLevelLink> */}

              <HeaderLinkGroupTitle variant="h3">Industries</HeaderLinkGroupTitle>
              <MobileHeaderLink onClick={closeMenu} to={industriesMeta.url}>
                All
              </MobileHeaderLink>
              <MobileHeaderLink onClick={closeMenu} to={maritimeMeta.url}>
                Maritime
              </MobileHeaderLink>
              <MobileHeaderLink onClick={closeMenu} to={mobileMeta.url}>
                Mobile Machines
              </MobileHeaderLink>
              <MobileHeaderLink onClick={closeMenu} to={computerMeta.url}>
                Machine Vision
              </MobileHeaderLink>
              <MobileHeaderLink onClick={closeMenu} to={otherMeta.url}>
                Others
              </MobileHeaderLink>

              {/* <Divider /> */}
              {/* <MobileHeaderTopLevelLink onClick={closeMenu} to={''}>
                applications
              </MobileHeaderTopLevelLink>

              <Divider />
              <MobileHeaderTopLevelLink onClick={closeMenu} to={''}>
                customer cases
              </MobileHeaderTopLevelLink> */}

              {/* <Divider />
              <MobileHeaderTopLevelLink onClick={closeMenu} to={''}>
                company
              </MobileHeaderTopLevelLink> */}

              <Divider />
              <HeaderLinkGroupTitle variant="h3">Applications</HeaderLinkGroupTitle>
              <MobileHeaderLink onClick={closeMenu} to={automatedDataPipelinesMeta.url}>
                Training
              </MobileHeaderLink>

              <MobileHeaderLink onClick={closeMenu} to={autoDockingMeta.url}>
                Testing
              </MobileHeaderLink>

              <Divider />
              <HeaderLinkGroupTitle variant="h3">Company</HeaderLinkGroupTitle>
              <MobileHeaderLink onClick={closeMenu} to={aboutMeta.url}>
                About us
              </MobileHeaderLink>

              <MobileHeaderLink onClick={closeMenu} to={careersMeta.url}>
                Careers
              </MobileHeaderLink>

              <Box mt={2}>
                <ContactUsButton
                  onClick={openModal}
                  color="secondary"
                  variant={'outlined'}
                  sx={{
                    width: '100%',
                    fontSize: '16px',
                  }}
                >
                  Contact us
                </ContactUsButton>
              </Box>
            </MobileNavigation>
          )}
        </MobileHeaderContainer>
      </ClickAwayListener>
    </>
  );
};
